import { computeCompositeModifierPlu } from 'utils/vendor-config';

import { IComputeItemOptionModifierPlu } from './types';

export const computePluForItemOptionModifier = ({
  item,
  modifier,
  vendor,
}: IComputeItemOptionModifierPlu) => {
  return computeCompositeModifierPlu({
    item,
    modifier,
    vendor,
  });
};
